// ═══════════════════════════════════════════════════════════════
// HEBREW CALENDAR UTILITIES
// ═══════════════════════════════════════════════════════════════

const HEBREW_MONTHS_HE = ['ניסן','אייר','סיון','תמוז','אב','אלול','תשרי','חשון','כסלו','טבת','שבט','אדר','אדר ב׳']
const HEBREW_MONTHS_EN = ['Nissan','Iyar','Sivan','Tammuz','Av','Elul','Tishrei','Cheshvan','Kislev','Tevet','Shevat','Adar','Adar II']

const HEB_NUMS = {
  1:'א',2:'ב',3:'ג',4:'ד',5:'ה',6:'ו',7:'ז',8:'ח',9:'ט',
  10:'י',20:'כ',30:'ל',40:'מ',50:'נ',60:'ס',70:'ע',80:'פ',90:'צ',
  100:'ק',200:'ר',300:'ש',400:'ת'
}

function numToHeb(n) {
  if(n <= 0) return ''
  if(n === 15) return 'ט״ו'
  if(n === 16) return 'ט״ז'
  let r = '', rem = n
  for(const v of [400,300,200,100,90,80,70,60,50,40,30,20,10,9,8,7,6,5,4,3,2,1]) {
    while(rem >= v) { r += HEB_NUMS[v]; rem -= v }
  }
  if(r.length > 1) r = r.slice(0,-1) + '״' + r.slice(-1)
  else r = r + '׳'
  return r
}

function isLeapYear(y) { return ((7*y)+1)%19 < 7 }
function monthsInYear(y) { return isLeapYear(y) ? 13 : 12 }

function elapsedDays(y) {
  const m = Math.floor((235*y - 234)/19)
  const p = 12084 + 13753*m
  let d = m*29 + Math.floor(p/25920)
  if((3*(d+1))%7 < 3) d++
  return d
}

function yearDays(y) { return elapsedDays(y+1) - elapsedDays(y) }

function daysInMonth(m, y) {
  if([1,3,5,7,11].includes(m)) return 30
  if(m === 8) return yearDays(y)%10 === 5 ? 30 : 29
  if(m === 9) return yearDays(y)%10 === 3 ? 29 : 30
  if(m === 12) return isLeapYear(y) ? 30 : 29
  return 29
}

function toJD(d, m, y) {
  const EPOCH = 347995.5
  let jd = EPOCH + elapsedDays(y) - 1 + d
  if(m < 7) {
    for(let i=7; i<=monthsInYear(y); i++) jd += daysInMonth(i,y)
    for(let i=1; i<m; i++) jd += daysInMonth(i,y)
  } else {
    for(let i=7; i<m; i++) jd += daysInMonth(i,y)
  }
  return jd
}

function gregToJD(y, m, d) {
  return 367*y
    - Math.floor(7*(y+Math.floor((m+9)/12))/4)
    - Math.floor(3*(Math.floor((y+(m-9)/7)/100)+1)/4)
    + Math.floor(275*m/9)
    + d + 1721028.5
}

function jdToHebrew(jd) {
  const EPOCH = 347995.5
  jd = Math.floor(jd) + 0.5
  let y = Math.floor((jd - EPOCH) * 98496/35975351) - 1
  while(elapsedDays(y+1) <= jd - EPOCH) y++
  let m = jd < toJD(1,7,y) ? 7 : 1
  while(jd > toJD(daysInMonth(m,y),m,y)) m++
  const d = Math.round(jd - toJD(1,m,y) + 1)
  return {day:d, month:m, year:y}
}

export function gregorianToHebrew(gy, gm, gd) {
  return jdToHebrew(gregToJD(gy, gm, gd))
}

export function formatHebrewDate(gy, gm, gd) {
  const h = gregorianToHebrew(gy, gm, gd)
  const mName = HEBREW_MONTHS_HE[h.month-1]
  const yearStr = numToHeb(h.year % 1000)
  const dayStr = numToHeb(h.day)
  return `${dayStr} ${mName} ${yearStr}`
}

export function getHebrewMonthLabel(gy, gm, gd) {
  const h = gregorianToHebrew(gy, gm, gd)
  return HEBREW_MONTHS_HE[h.month-1] + ' ' + numToHeb(h.year % 1000)
}

// ── PARSHA ────────────────────────────────────────────────────
const PARSHIYOS = [
  'בְּרֵאשִׁית','נֹחַ','לֶךְ לְךָ','וַיֵּרָא','חַיֵּי שָׂרָה','תּוֹלְדֹת',
  'וַיֵּצֵא','וַיִּשְׁלַח','וַיֵּשֶׁב','מִקֵּץ','וַיִּגַּשׁ','וַיְחִי',
  'שְׁמוֹת','וָאֵרָא','בֹּא','בְּשַׁלַּח','יִתְרוֹ','מִּשְׁפָּטִים',
  'תְּרוּמָה','תְּצַוֶּה','כִּי תִשָּׂא','וַיַּקְהֵל פְקוּדֵי','וַיִּקְרָא',
  'צַו','שְׁמִינִי','תַזְרִיעַ מְצֹרָע','אַחֲרֵי מוֹת קְדֹשִׁים',
  'אֱמוֹר','בְּהַר בְּחֻקֹּתַי','בְּמִדְבַּר','נָשֹׂא','בְּהַעֲלֹתְךָ',
  'שְׁלַח לְךָ','קֹרַח','חֻקַּת בָּלָק','פִּינְחָס',
  'מַטּוֹת מַסְעֵי','דְּבָרִים','וָאֶתְחַנַּן','עֵקֶב','רְאֵה',
  'שֹׁפְטִים','כִּי תֵצֵא','כִּי תָבוֹא','נִצָּבִים וַיֵּלֶךְ','הַאֲזִינוּ',
  'וְזֹאת הַבְּרָכָה'
]

// Reference Shabbos: Oct 25 2025 = Shabbos Bereishis 5786
const REF_JD = gregToJD(2025, 10, 25)
const REF_IDX = 0

export function getParshaForShabbos(gy, gm, gd) {
  const jd = gregToJD(gy, gm, gd)
  const weeks = Math.round((jd - REF_JD) / 7)
  const idx = ((REF_IDX + weeks) % PARSHIYOS.length + PARSHIYOS.length) % PARSHIYOS.length
  return PARSHIYOS[idx]
}

// ── JEWISH HOLIDAYS ───────────────────────────────────────────
const HOLIDAYS = {
  '7-1':  {he:'ראש השנה',        en:'Rosh Hashana',       yomtov:true},
  '7-2':  {he:'ראש השנה',        en:'Rosh Hashana',       yomtov:true},
  '7-3':  {he:'צום גדליה',       en:'Tzom Gedaliah',      yomtov:false},
  '7-10': {he:'יום כיפור',       en:'Yom Kippur',         yomtov:true},
  '7-15': {he:'סוכות',           en:'Sukkos',             yomtov:true},
  '7-16': {he:'סוכות',           en:'Sukkos',             yomtov:true},
  '7-17': {he:'חול המועד',       en:'Chol Hamoed',        yomtov:false},
  '7-18': {he:'חול המועד',       en:'Chol Hamoed',        yomtov:false},
  '7-19': {he:'חול המועד',       en:'Chol Hamoed',        yomtov:false},
  '7-20': {he:'חול המועד',       en:'Chol Hamoed',        yomtov:false},
  '7-21': {he:'הושענא רבה',      en:'Hoshana Raba',       yomtov:false},
  '7-22': {he:'שמיני עצרת',      en:'Shemini Atzeres',    yomtov:true},
  '7-23': {he:'שמחת תורה',       en:'Simchas Torah',      yomtov:true},
  '9-25': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '9-26': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '9-27': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '9-28': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '9-29': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '9-30': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '10-1': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '10-2': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '10-3': {he:'חנוכה',           en:'Chanuka',            yomtov:false},
  '10-10':{he:'עשרה בטבת',       en:'Asara BeTevet',      yomtov:false},
  '11-15':{he:'ט״ו בשבט',        en:"Tu BiShvat",         yomtov:false},
  '12-13':{he:'תענית אסתר',      en:'Taanis Esther',      yomtov:false},
  '12-14':{he:'פורים',           en:'Purim',              yomtov:false},
  '12-15':{he:'שושן פורים',      en:'Shushan Purim',      yomtov:false},
  '1-15': {he:'פסח',             en:'Pesach',             yomtov:true},
  '1-16': {he:'פסח',             en:'Pesach',             yomtov:true},
  '1-17': {he:'חול המועד',       en:'Chol Hamoed Pesach', yomtov:false},
  '1-18': {he:'חול המועד',       en:'Chol Hamoed Pesach', yomtov:false},
  '1-19': {he:'חול המועד',       en:'Chol Hamoed Pesach', yomtov:false},
  '1-20': {he:'חול המועד',       en:'Chol Hamoed Pesach', yomtov:false},
  '1-21': {he:'שביעי של פסח',    en:'Shevii Shel Pesach', yomtov:true},
  '1-22': {he:'אחרון של פסח',    en:'Acharon Shel Pesach',yomtov:true},
  '2-18': {he:'ל״ג בעומר',       en:"Lag BaOmer",         yomtov:false},
  '2-28': {he:'יום ירושלים',     en:'Yom Yerushalayim',   yomtov:false},
  '3-6':  {he:'שבועות',          en:'Shavuos',            yomtov:true},
  '3-7':  {he:'שבועות',          en:'Shavuos',            yomtov:true},
  '4-17': {he:'י״ז בתמוז',       en:"17 Tammuz",          yomtov:false},
  '5-9':  {he:'תשעה באב',        en:'Tisha BeAv',         yomtov:false},
  '5-15': {he:'ט״ו באב',         en:"Tu BeAv",            yomtov:false},
}

export function getJewishHoliday(gy, gm, gd, inEnglish=true) {
  const h = gregorianToHebrew(gy, gm, gd)
  const key = `${h.month}-${h.day}`
  const hol = HOLIDAYS[key]
  if(hol) return inEnglish ? hol.en : hol.he
  // Rosh Chodesh (skip Tishrei - covered by RH)
  if((h.day === 1 || h.day === 30) && h.month !== 7) {
    const mName = inEnglish ? HEBREW_MONTHS_EN[h.month-1] : HEBREW_MONTHS_HE[h.month-1]
    return inEnglish ? `Rosh Chodesh ${mName}` : `ראש חודש ${mName}`
  }
  return null
}

export function isYomTov(gy, gm, gd) {
  const h = gregorianToHebrew(gy, gm, gd)
  const key = `${h.month}-${h.day}`
  return !!(HOLIDAYS[key]?.yomtov)
}
